import { t } from 'i18next'
import { useNotifications } from '../useNotifications'
import type { Activity, CalculationResult } from './types'
import { useGetCalculationResultsQuery } from './types'

interface UseCalculationActivityHook {
  loading: boolean
  results: Array<CalculationResult>
}

export const useCalculationActivity = ({ activity }: { activity: Activity }): UseCalculationActivityHook => {
  const { id: activity_id, stream_id: pathway_id } = activity

  const { notifyError } = useNotifications()
  const { data, loading, error } = useGetCalculationResultsQuery({
    variables: {
      activity_id,
      pathway_id
    }
  })
  if (loading) {
    return {
      loading,
      results: []
    }
  }

  if (error) {
    notifyError({
      error,
      message: t('get_calculation_result_error_notification')
    })
    return { loading: false, results: [] }
  }

  return {
    loading,
    results: data?.calculationResults?.result ?? []
  }
}
